import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { IntroductionComponent } from './introduction/introduction.component';
import { NavComponent } from './nav/nav.component';
import { AppRoutingModule } from './app-routing.module';
import { FirmInformationComponent } from './firm-information/firm-information.component';
import { InvestmentStrategyMainComponent } from './investment-strategy-main/investment-strategy-main.component';
import { OpenEndFundsComponent } from './open-end-funds/open-end-funds.component';
import { ClosedEndFundsComponent } from './closed-end-funds/closed-end-funds.component';
import { OtherFundsComponent } from './other-funds/other-funds.component';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './footer/footer.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { RecaptchaModule } from 'ng-recaptcha';
@NgModule({
   declarations: [
      AppComponent,
      IntroductionComponent,
      NavComponent,
      FirmInformationComponent,
      InvestmentStrategyMainComponent,
      OpenEndFundsComponent,
      ClosedEndFundsComponent,
      OtherFundsComponent,
      FooterComponent,
      ThankYouComponent
   ],
   imports: [
      BrowserModule,
      HttpClientModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      FormsModule,
      ReactiveFormsModule,
      BsDatepickerModule.forRoot(),
      NgbModule,
      RecaptchaModule.forRoot()
   ],
   providers: [],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }
